import { render, staticRenderFns } from "./ActivateCondominiumModal.vue?vue&type=template&id=48ddbbd6&scoped=true"
import script from "./ActivateCondominiumModal.vue?vue&type=script&lang=js"
export * from "./ActivateCondominiumModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateCondominiumModal.vue?vue&type=style&index=0&id=48ddbbd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddbbd6",
  null
  
)

export default component.exports